export default "__VITE_PUBLIC_ASSET__6479d83a__"